/* eslint-disable no-shadow */
import Vue from 'vue';
import Proxy from '@/proxies/ContractSearchProxy';
import emitter from '@/plugins/emitter';
import { i18n } from '@/plugins/vue-i18n';

export const getDefaultState = () => ({
  contractHash: null,
  // only available for CC-agent:
  contractSegment: null,
  groupKey: null,
  phone: null,
  status: null,
  tariffName: null,
  tariffId: null,
  invoiceNumber: null,
  customerNumber: null,
  wholesalerId: null,
  wholesalerName: null,
  identifierInfo: null,
  accessMode: null,
  exemptedFromTax: false,

  // internal:
  isPending: false,
});

export const state = getDefaultState();

export const types = {
  RESET: 'RESET',
  RESTORE: 'RESTORE',
  SEARCH: 'SEARCH',
  SET: 'SET',
};

export const mutations = {
  [types.RESET](state) {
    Object.assign(state, getDefaultState());
    sessionStorage.removeItem('contract');
    Vue.$http.defaults.headers.common.contractHash = '';
  },

  [types.RESTORE](state) {
    try {
      let contract = JSON.parse(sessionStorage.getItem('contract'));
      Object.assign(state, contract);

      Vue.$http.defaults.headers.common.contractHash = contract?.contractHash || '';
    } catch (e) {
      // payload invalid!
    }
  },

  [types.SET](state, contract) {
    Object.entries(getDefaultState()).forEach(([k, v]) => {
      state[k] = contract[k] !== undefined ? contract[k] : v;
    });

    sessionStorage.setItem('contract', JSON.stringify(state));

    Vue.$http.defaults.headers.common.contractHash = state.contractHash || '';
  },
};

export const getters = {
  isContract: (state) => !!state.contractHash && !state.isPending,
  hasValidIdentifier: (state) =>
    state.contractHash && state.identifierInfo && state.identifierInfo.NIK0 && state.identifierInfo.NIK0.name && state.identifierInfo.NIK0.value,
  isExemptedFromTax: (state) => state.exemptedFromTax,
};

export const actions = {
  reset({ commit }) {
    commit(types.RESET);
  },

  autoInit({ commit }) {
    commit(types.RESTORE);
  },

  async search({ commit, dispatch }, values) {
    const response = await new Proxy({ ...values, locale: i18n.locale }).search();
    commit(types.SET, { contractHash: response.contractHash, isPending: true });
    await dispatch('customer/set', { customerHash: response.customerHash }, { root: true });
    await dispatch('system/reInit', null, { root: true });
  },

  set({ commit }, contract) {
    commit(types.SET, contract);
  },

  async change({ commit, dispatch, state, rootGetters }, { uniqueSubscriptionId }) {
    if (!rootGetters['shared/isCustomerTab']) {
      return;
    }
    const response = await new Proxy({ uniqueSubscriptionId, locale: i18n.locale }).change();
    if (response.contractHash === state.contractHash) {
      // contract already selected
      return;
    }
    commit(types.SET, { contractHash: response.contractHash });
    await dispatch('customer/set', { customerHash: response.customerHash }, { root: true });
    await dispatch('system/reInit', null, { root: true });
    dispatch('shared/setCustomerTab', true, { root: true });
    emitter.emit('contractChanged');
  },
};
